import { type DatePickerOption } from './types'

const DATE_PICKER_MAX_MONTH = 12
const DATE_PICKER_MONTH_OPTION_PAD = 2

export const datePickerGetMonthOptions = (): DatePickerOption[] => {
  return Array.from(
    { length: DATE_PICKER_MAX_MONTH },
    (_unusedValue, monthIndex) => {
      const month = monthIndex + 1

      return {
        text: String(month).padStart(DATE_PICKER_MONTH_OPTION_PAD, '0'),
        value: month,
      }
    },
  )
}
